<section *ngIf="!noHeader" class="header align-items-end">
  <div class="header__content-header d-flex flex-column align-items-start gap-2">
    <div>
      <h3 class="subtitle">{{ tableTitle }}</h3>
    </div>
    <div class="container__searcher">
      <div *ngIf="filtersFields" class="container__searcher--filters_no_searcher">
        <signaturit-table-filters [fields]="filtersFields" [title]="filtersTitle" [options]="filtersOptions" [id]="tableId"
          (onFiltersSet)="setFilters($event)">
        </signaturit-table-filters>
      </div>
    </div>
    <div>
      <signaturit-button id="btnCSV" *ngIf="hasCSVBtn" text="{{'detallecircuito_toolbar_4' | translate}}"
        type="tertiary" size="md" [disabled]="!dataSource.length" (click)="downloadCSV()"></signaturit-button>
      <signaturit-button *ngIf="hasCSVBtn" text="{{'label_opcionesCsv'|translate}}" type="tertiary" size="md"
        [disabled]="!dataSource.length" (click)="openCSV()"></signaturit-button>
      <mat-checkbox *ngIf="hasActionsBtn" [checked]="allSelected" (change)="selectAll($event.checked)"
        class="header__content-header--check-select">{{ 'table.select_all' | translate }}</mat-checkbox>
      <button *ngIf="hasActionsBtn" class="header__content-header--actions-button" mat-button [matMenuTriggerFor]="menu"
        [disabled]="!elementsSelected.length">
        {{ 'table.actions' | translate }}
        <mat-icon>arrow_drop_down</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <ng-container *ngFor="let a of actionsMenuOptions">
          <button class="menu-button" mat-menu-item (click)="onclickAction(a.key)">{{a.value}}</button>
        </ng-container>
      </mat-menu>
    </div>
  </div>
  <div class="paginator">
    <mat-paginator [showFirstLastButtons]="true" [hidePageSize]="true" [length]="countRegister" [pageSize]="pageSize"
      id="tablePaginator">
    </mat-paginator>
  </div>
</section>
<div class="tableContainer">
  <table mat-table [dataSource]="dataSource" class="mat-elevation-z" id="genericTable">
    <div *ngFor="let col of displayedColumns; let i = index">
      <ng-container *ngIf="col.visible" matColumnDef="{{ col.key }}">
        <th mat-header-cell *matHeaderCellDef class="headerRow" [ngStyle]="
          col.key !== 'options' ? { width: dynamicWidth } : { width: '1%' }">
          <div *ngIf="col.key !== 'options'" class="headerRow__arrow" (click)="sortColumns(col.orderKey)">
            {{ col.value }}
            <mat-icon class="headerRow__arrow--icon-arrow">{{arrowIcon}}</mat-icon>
          </div>
        </th>
        <td [id]="col.key" mat-cell *matCellDef="let element" class="contentRow" [attr.data-label]="col.value"
          [ngClass]="{'subitem-col': element.parentId > 0}">
          <!-- Show checkbox -->
          <mat-checkbox [checked]="isSelected(element, col.key)"
            *ngIf="i === 0 && hasActionsBtn && element['default'] !== 1" class="contentRow__checkbox"
            (change)="onSelectRow($event.checked, element, col.key)">
          </mat-checkbox>
          <!-- First column. Icon possibility -->
          <div *ngIf="i === 0 && col.type !== 6" class="contentRow__first d-flex">
            <!-- SPECIFIC TO AREA -->
            <div *ngIf="element.level" [ngClass]="('subitem-spacing-' + (element.level))"></div>
            <mat-icon *ngIf="element.children?.length > 0" class="cursor-pointer subitem-arrow"
              [ngClass]="hasActionsBtn ? 'contentRow__showIcon' : 'contentRow__icon'" (click)="toggleSubareas(element)">
              <ng-container *ngIf="!element.opened">arrow_right</ng-container>
              <ng-container *ngIf="element.opened">arrow_drop_down</ng-container>
            </mat-icon>
            <!-- END SPECIFIC TO AREA -->
            <mat-icon *ngIf="col?.icon && element[col.iconCondition]"
              [ngClass]="{'contentRow__showIcon' : hasActionsBtn, 'contentRow__icon': !hasActionsBtn}">
              {{ col.icon }}
            </mat-icon>
            <span class="text-nowrap">{{ element[col.key] }}</span>
          </div>
          <!-- From second column. Type string or number -->
          <div *ngIf="i > 0 && (col.type === 0 || col.type === 1)">
            {{ element[col.key]}}
          </div>
          <!-- Boolean type -->
          <div *ngIf="col.type === 3 && col.booleanValues?.length">
            <div *ngIf="col.showClassBoolean && !col.warningClass"
              [ngClass]="{'expiredState': element[col.key] === false, 'activeState': element[col.key] === true }">
              {{ element[col.key] | boolState: col?.booleanValues }}
            </div>
            <div *ngIf="col.showClassBoolean && col.warningClass"
              [ngClass]="{'pendingState': element[col.key] === false, 'activeState': element[col.key] === true }">
              {{ element[col.key] | boolState: col?.booleanValues }}
            </div>
            <div *ngIf="!col.showClassBoolean">
              {{ element[col.key] | boolState: col?.booleanValues }}
            </div>
          </div>
          <!-- Date type -->
          <div *ngIf="col.type === 2">
            {{ element[col.key] | date: 'dd/MM/yyyy HH:mm' }}
          </div>
          <!-- Options column with kebab menu -->
          <div *ngIf="col.type === 4 && kebabMenuOptions.length">
            <signaturit-kebab-menu [tableId]="tableId" (clickKebabOption)="onclickKebab($event)" [element]="element"
              [kebabMenuOptions]="kebabMenuOptions" [kebabMenuOptionsFilter]="kebabMenuOptionsFilter">
            </signaturit-kebab-menu>
          </div>
          <!-- Image type -->
          <div class="contentRow__image" *ngIf="col.type === 6 && element[col.key]">
            <img [ngClass]="{'contentRow__image--default': hasActionsBtn && element['default'] === 1 }"
              src="data:image/png;base64,{{element[col.key]}}" />
          </div>
          <!-- State type -->
          <div *ngIf="col.type === 7">
            <div [ngClass]="getClassState(element?.idState || element?.idEstado, element[col.key])">
              <ng-container *ngIf="element[col.key] === 'ACTIVE'">
                {{ 'label_active' | translate }}
              </ng-container>
              <ng-container *ngIf="element[col.key] === 'INACTIVE'">
                {{ 'label_inactive' | translate }}
              </ng-container>
              <ng-container *ngIf="element[col.key] !== 'ACTIVE' && element[col.key] !== 'INACTIVE'">
                {{ element[col.key] }}
              </ng-container>
            </div>
          </div>
          <!-- Object type -->
          <div *ngIf="col.type === 8">
            {{ getStringObject(element[col.key]) }}
          </div>
        </td>
      </ng-container>
    </div>
    <tr mat-header-row *matHeaderRowDef="columnsToShow"></tr>
    <tr class="tableClick" (dblclick)="onRowDoubleClick(row)" mat-row *matRowDef="let row; columns: columnsToShow"></tr>
  </table>
</div>
